<div class="PGDetail card-text">
    @for (formGroup of formLayout.formGroups; track formGroup) {
        @if (formLayout.isGroupVisible(formGroup)) {
            @if (formGroup.fields != null) {
                <div class="PGDetail-Group">
                    @if (formGroup.title != null && formGroup.title != '') {
                        <div class="row PGDetail-Group-Head">
                            <div class="col-12">
                                <h4>{{formGroup.title | locTranslate}}</h4>
                                <hr/>
                            </div>
                        </div>
                    }
                    <div class="row PGDetail-Group-Body">
                        @if (formGroup.description != null) {
                            <div class="col col-12 mb-3" [innerHTML]="formGroup.description | locTranslate"></div>
                        }
                        @for (groupField of formGroup.fields; track groupField) {
                            @if (formLayout.getFieldByName(groupField.name); as fieldData;) {
                                @if (isFieldVisible(groupField)) {
                                    <div class="col col-{{formLayout.getFieldWidth(groupField)}}">
                                        <div class="PGDetail-Group-Element">
                                            <app-pg-detail-field [fieldData]="fieldData" [value]="getValueForField(fieldData)" [languages]="getLanguages()" [currency]="getCurrency()"></app-pg-detail-field>
                                        </div>
                                    </div>
                                }
                            }
                        }
                    </div>
                </div>
            }
        }
    }
</div>